import {css, StyleSheet} from 'aphrodite';
import React from 'react';

export interface FlowchartTransitionsSidepanelContentProps {}

const styles = StyleSheet.create({
  container: {
    padding: '16px',
  },
  title: {
    fontSize: '16px',
    fontWeight: 600,
    marginBottom: '16px',
  },
});

export default function FlowchartTransitionsSidepanelContent(
  props: FlowchartTransitionsSidepanelContentProps
): JSX.Element {
  return (
    <div className={css(styles.container)}>
      <div className={css(styles.title)}>TODO - implement flowchart transitions sidepanel</div>
    </div>
  );
}
